export default "__VITE_ASSET__Bm0S7YRI__"